module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS9.41d0cf2e.jpg";